<template>
    <card>
        <h5 class="form-title">Transaksi Disposal</h5>
        <p class="form-subtitle">
            Status berubah jadi Partial saat satu ID ditemukan dan jadi Done setelah kedua ID ditemukan.
        </p>

        <hr class="section-divider" />

        <div class="row">
            <div class="col-md-6">
                <div class="form-group mb-0">
                    <label class="field-label">Transaksi ID ERP</label>
                    <div class="input-with-icon">
                        <input
                            type="text"
                            class="form-control readonly-field"
                            :class="{ 'is-invalid': erpHasError }"
                            :value="transaksiIdErp || '-'"
                            readonly
                        />
                        <i v-if="!erpHasError" class="fa fa-check-circle status-icon status-icon-success"></i>
                    </div>
                    <p v-if="erpHasError" class="field-error">{{ erpErrorMessage }}</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group mb-0">
                    <label class="field-label">Transaksi ID Jurnal</label>
                    <div class="input-with-icon">
                        <input
                            type="text"
                            class="form-control readonly-field"
                            :class="{ 'is-invalid': jurnalHasError }"
                            :value="transaksiIdJurnal || '-'"
                            readonly
                        />
                        <i v-if="!jurnalHasError" class="fa fa-check-circle status-icon status-icon-success"></i>
                    </div>
                    <p v-if="jurnalHasError" class="field-error">{{ jurnalErrorMessage }}</p>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-3" v-if="(erpHasError || jurnalHasError) && (!errJurnalMessage && !errErpMessage)">
            <button
                class="btn btn-primary proses-ulang-btn"
                :disabled="loading"
                @click="$emit('proses-ulang')"
            >
                {{ loading ? 'Memproses...' : 'Proses Ulang' }}
            </button>
        </div>
    </card>
</template>

<script>
import { Card } from '../../Layout';

export default {
    name: 'TransaksiDisposalCard',
    components: {
        Card,
    },
    props: {
        transaksiIdErp: {
            type: String,
            default: '',
        },
        transaksiIdJurnal: {
            type: String,
            default: '',
        },
        errErpMessage: {
            type: String,
            default: '',
        },
        errJurnalMessage: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        erpHasError() {
            return !this.transaksiIdErp || !!this.errErpMessage;
        },
        jurnalHasError() {
            return !this.transaksiIdJurnal || !!this.errJurnalMessage;
        },
        erpErrorMessage() {
            return this.errErpMessage || 'Transaksi ID ERP gagal dibuat';
        },
        jurnalErrorMessage() {
            return this.errJurnalMessage || 'Transaksi ID Jurnal gagal dibuat';
        },
    },
};
</script>

<style scoped>
.form-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
    color: #212529;
}

.form-subtitle {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 0;
}

.section-divider {
    border: none;
    border-top: 1px solid #e9ecef;
    margin: 16px 0 20px;
}

.field-label {
    font-size: 13px;
    font-weight: 500;
    color: #343a40;
    margin-bottom: 4px;
}

.readonly-field {
    background-color: #f8f9fa;
    color: #6c757d;
}

.input-with-icon {
    position: relative;
}

.status-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
}

.status-icon-success {
    color: #28a745;
}

.is-invalid {
    border-color: #dc3545 !important;
}

.field-error {
    font-size: 12px;
    color: #dc3545;
    margin: 4px 0 0;
}

.proses-ulang-btn {
    font-size: 13px;
    padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Disposal/CustomComponent/TransaksiDisposalCard.vue